exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tc-container {\n\tpadding: 15px 0 20px;\n\ttext-align: justify;\n}\n.__header-margin {\n\tmargin-bottom: 57px !important;\n}\n", ""]);

// exports
